module.exports = __webpack_public_path__ + "by.ad33ee06.svg";